export const formatNumberToCurrency = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency
  }).format(amount);
};

export const formatDateToText = (date?: string) => {
  if (!date) return '';
  return new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(date));
};

//eslint-disable-next-line
export const getErrorMessage = (error: any, defaultErrorMsg?: string): string => {
  if (typeof error === 'string') return error;
  if (error && error?.data?.message && typeof error?.data.message === 'string')
    return error?.data.message;
  if (defaultErrorMsg) return defaultErrorMsg;
  return 'An error occurred';
};
